import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SuggestCitiesService {
    hasFilteredItems: boolean = false;
}
